import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { useFormikContext } from 'formik'
import { CreateAgreementFormModel } from '../../typings'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Alert, { alertClasses } from '@mui/material/Alert'

export const DetailsCheckbox: React.FC = () => {
  const {
    values: { includeDetail },
    setFieldValue,
  } = useFormikContext<CreateAgreementFormModel>()

  const onChange = React.useCallback(
    (_, checked: boolean) => setFieldValue('includeDetail', checked),
    [setFieldValue],
  )

  const theme = useTheme()

  return (
    <>
      <Box sx={{ marginBottom: theme.spacing(1) }}>
        <Alert
          severity="info"
          sx={{
            [`& .${alertClasses.icon}`]: { marginTop: theme.spacing(-6.5) },
          }}
        >
          <Box mb={0.5}>
            <Typography
              variant="subtitle1"
              sx={{
                lineHeight: '24px',
                fontWeight: '600',
              }}
              color="info"
            >
              Service Details Replaced with Summary
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2">
              There is not enough space on this template for the service <br />
              details. Select the box below to include the details as an <br />{' '}
              extra page.
            </Typography>
          </Box>
        </Alert>
      </Box>
      <FormControlLabel
        sx={{
          marginLeft: theme.spacing(0.5),
          marginBottom: theme.spacing(0),
        }}
        onChange={onChange}
        label={
          <Typography variant="body2">
            Include Service Details on a new page
          </Typography>
        }
        control={<Checkbox color="primary" checked={includeDetail} />}
      />
    </>
  )
}
DetailsCheckbox.displayName = 'DetailsCheckbox'
